// Action Widgets - Simulate, Share and PDF Proposal buttons

import { Button } from "@/components/ui/button";
import { Calculator, Loader2, Save, FileText } from "lucide-react";

export const SimulateButtonWidget = ({ onSimulate, isCalculating }) => (
  <div className="p-2 h-full flex items-center justify-center">
    <Button 
      onClick={onSimulate}
      disabled={isCalculating}
      className="w-full h-10 text-sm font-semibold"
      size="lg"
    >
      {isCalculating ? (
        <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          A calcular...
        </>
      ) : (
        <>
          <Calculator className="w-4 h-4 mr-2" />
          Simular
        </>
      )}
    </Button>
  </div>
);

export const ShareWidget = ({ onShare, onGeneratePDF, hasResults }) => (
  <div className="p-3 h-full flex items-center justify-center gap-2">
    <Button 
      variant="outline" 
      className="flex-1" 
      onClick={onShare}
      disabled={!hasResults}
      data-testid="save-proposal-btn"
      title="Guardar simulação na lista de candidatos"
    >
      <Save className="w-4 h-4 mr-2" />
      Guardar Proposta
    </Button>
    <Button 
      className="flex-1 bg-[var(--brand-primary)] hover:bg-[var(--brand-primary)] text-white"
      onClick={onGeneratePDF}
      disabled={!hasResults}
      data-testid="generate-proposal-btn"
    >
      <FileText className="w-4 h-4 mr-2" />
      Proposta PDF
    </Button>
  </div>
);
